import { ContextMenuLibrary } from "../../../library-templates/context--menu/ContextMenuLibrary";
import { News_de } from "./de/News_de";
import { Auto_en } from "./en/Auto_en";
import { Git_en } from "./en/Git_en";
import { Labs_en } from "./en/Labs_en";
import { News_en } from "./en/News_en";
import { Projects_en } from "./en/Projects_en";

export class RJContextMenus extends ContextMenuLibrary
{
  constructor()
  {
    super();

    let menus = 
    [
      new Projects_en(),
      new News_en(),
      new News_de(),
      new Labs_en(),
      new Auto_en()      
    ];

    this._setAll( menus );
  }
}